import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
import { useServicesStore } from "@/stores/useServicesStore";
export const useSpec = specId => {
  const $ = _c(9);
  const artClientPublic = useServicesStore(_temp);
  let t0;
  if ($[0] !== specId) {
    t0 = ["spec", specId];
    $[0] = specId;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== artClientPublic || $[3] !== specId) {
    t1 = async () => {
      if (!artClientPublic || !specId) {
        return;
      }
      return artClientPublic.getSpec(specId);
    };
    $[2] = artClientPublic;
    $[3] = specId;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const t2 = !!specId && !!artClientPublic;
  let t3;
  if ($[5] !== t0 || $[6] !== t1 || $[7] !== t2) {
    t3 = {
      queryKey: t0,
      queryFn: t1,
      enabled: t2,
      staleTime: Infinity
    };
    $[5] = t0;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return useQuery(t3);
};
function _temp(state) {
  return state.artClientPublic;
}